import React, { useState, useEffect } from 'react';
import { API_URL, customStyles, secret_key, storedData } from '../components/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import Swal from "sweetalert2";
import Modal from 'react-modal';
import CryptoJS from "crypto-js";
import { Link, useNavigate } from 'react-router-dom';
import loading1 from "../assets/loading.gif"
import Papa from 'papaparse';

function ContactGroupsForCompany() {
  const [searchTerm, setSearchTerm] = useState('');
  const [contactgroups, setContactgroups] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [companies, setCompany] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  let navigate = useNavigate();

  const fetchContactGroups = () => {
    const getContactGroupssURL = `${API_URL}/get_groupsByCompanyid/${logeduserData?.company_id}?page=${page}&limit=${50}`;

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactGroupssURL,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      if (response.data.length === 0) {
        setHasMore(false);
      } else {
        setContactgroups([...contactgroups, ...response.data]);
        setPage(page + 1);
      }
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        navigate(0);
      }
    });
  };

  useEffect(() => {
    if (searchTerm === "") {
      setContactgroups([]);
      setPage(1);
      setHasMore(true);
      fetchContactGroups();
    }
  }, [searchTerm]);
  

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setPage(1);
    setContactgroups([]);
    setHasMore(true);
  };
  

  const filteredContactGroups = contactgroups.filter((contactgroup) => {
    const { group_name, description } = contactgroup;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      group_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      description.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const loadMoreContactGroups = () => {
    fetchContactGroups(); // Fetch more contacts when the user scrolls to the bottom
  };

  // const fetchCompanies = () => {
  //   let config = {
  //     method: 'get',
  //     maxBodyLength: Infinity,
  //     url: `${API_URL}/get_companies`,
  //     headers: { 
  //       'Authorization': token
  //     }
  //   }
    
  //   axios.request(config)
  //   .then((response) => {
  //     const formattedOptions = response.data.map((company) => ({
  //       value: company.id,
  //       label: company.id+". "+company.name
  //     }));
  //     setCompany(formattedOptions);
  //   })
  //   .catch((error) => {
  //     console.log(error?.response)
  //   });
  // };
  // useEffect(() => {
  //   fetchCompanies();
  // }, []);


  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
      setIsOpen(true);
    }
  
    const closeModal = () => {
      setIsOpen(false);
    }

  const [groupdata, setGroupData] = useState({
    group_name: "",
    company_id: logeduserData?.company_id,
    company_label: logeduserData?.company_id + ". " + logeduserData?.company_name,
    description: "",
  });

  const handleChange = (e) =>{
    const newdata = { ...groupdata }
    newdata[e.target.id] = e.target.value
    setGroupData(newdata)
  } 

  const createContactGroup = (ev) => {
    ev.preventDefault();

    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/new_contactgroup`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : groupdata
    };
    
    axios.request(config)
    .then((response) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Contact group was created successfully",
      })
      .then(() => {
        navigate(0);
      });
    })
    .catch((error) => {
      setIsSubmitting(false);
       Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        });
    });
  }

  const openContacts = (group_id, groupname) => {
    navigate(`/contactlist/${group_id}?contact_group=${encodeURIComponent(groupname)}`);
  }


  const [editmodalIsOpen, setEditIsOpen] = useState(false);
  const [grouptoedit, setgrouptoedit] = useState("");
  const [editcontactgrp, seteditcontactgrp] = useState({
    group_name: "",
    description: ""
  });
  const openEditModal = (groupid) => {
    setEditIsOpen(true);
    setgrouptoedit(groupid)

    const getGroupByID = () => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_groupByid/${groupid}`,
        headers: { 
          'Authorization': token
        }
      }
      
      axios.request(config)
      .then((response) => {
        seteditcontactgrp(response.data)         
      })
      .catch((error) => {
        console.log(error?.response)
      });
    };
    
    getGroupByID();
  }

  const closeEditModal = () => {
    setEditIsOpen(false);
  }

  const handleeditChange = (e) => {
    const editdata = { ...editcontactgrp }
    editdata[e.target.id] = e.target.value
    seteditcontactgrp(editdata)
  }

  const editContactGroup = (ev) => {
    ev.preventDefault()  
    
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${API_URL}/edit_contact_group/${grouptoedit}`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : editcontactgrp
    };
    
    axios.request(config)
    .then((response) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Contact group edited successfully",
      })
      .then(() => {
        navigate(0);
      });
    })
    .catch((error) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      });
    });
  }

  const openExcelModal = (groupid) => {
    const fileInput = document.getElementById('file-input');
    if (fileInput) {
      fileInput.click(); // Trigger file input click event
      fileInput.addEventListener('change', (event) => {
        const file = event.target.files[0];
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsedData = results.data
              .map(item => ({ 
                ...item,
                contact_group_id: groupid,
                company_id: logeduserData?.company_id
              }));
  
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: `${API_URL}/new_group_contact`,
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': token
              },
              data: parsedData
            };
  
            axios.request(config)
              .then((response) => {
                Swal.fire({
                  icon: "success",
                  title: "Success!",
                  text: "Contacts were imported successfully",
                }).then(() => {
                  navigate(0);
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: "Failed",
                });
              });
          },
        });
      });
    }
  };

  const deleteContactGroup = (groupid) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {

        if (isSubmitting) {
          return;
        }
    
        setIsSubmitting(true);
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/delete_contact_group/${groupid}`,
          headers: {
            'Authorization': token
          }
        };
        
        axios.request(config)
        .then((response) => {
          setTimeout(() => {
            setIsSubmitting(false);
            Swal.fire({
              title: 'Deleted!',
              text: 'The group has been deleted.',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
            })
            .then(() => {
              navigate(0);
            });
          }, 500);
          // window.location.reload();
        })
        .catch((error) => {
          setIsSubmitting(false);
           Swal.fire({
              icon: "error",
              title: "Error!",
              text: error?.response?.data?.error,
            });
        });
      }
    });
  }

  return (
     <div style={{ paddingLeft: '10px' }}>
      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}

        <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Contact Groups</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Groups</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              New Contact Group
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={createContactGroup}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Group Name</span>
                    <input type="text" 
                      placeholder="Enter group name" 
                      required 
                      onChange={handleChange}
                      id='group_name'
                    />
                  </div>

                  <div className="input-box">
                  <span className="details">Description</span>
                      <textarea
                      id="description"
                      placeholder="Enter group description"
                      required
                      onChange={handleChange}
                      rows="4"
                      />
                  </div>  
                              
                </div>
               
                <div className="button">
                <input type="submit" defaultValue="Save" />
                </div>
              </form>
            </div>
          </div>

        </Modal>


        <Modal
          isOpen={editmodalIsOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Edit Contact Group
              <i onClick={closeEditModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={editContactGroup}> 
                <div className="user-details">
                
                  <div className="input-box">
                    <span className="details">Group Name</span>
                    <input type="text" 
                      placeholder="Enter group name" 
                      required 
                      onChange={handleeditChange}
                      id='group_name'
                      value={editcontactgrp.group_name || ''}
                    />
                  </div>
              
                  <div className="input-box">
                    <span className="details">Description</span>
                        <textarea
                        id="description"
                        placeholder="Enter group description"
                        required
                        onChange={handleeditChange}
                        rows="4"
                        value={editcontactgrp.description || ''}
                        />

                  </div>
                </div>
               
                <div className="button">
                  <input type="submit" value="Update" />
                </div>
              </form>
            </div>
          </div>

        </Modal>

      <form className="form-inline justify-content-end searchBar">
      <div id="add-btn" onClick={openModal}>
      <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
      Add Contact Group
      </div>

        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

          <InfiniteScroll

            dataLength={filteredContactGroups.length}
            next={loadMoreContactGroups}
            hasMore={hasMore}
            loader={filteredContactGroups.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more contacts groups to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Group Name</th>
                  <th>Total Contacts</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                  {filteredContactGroups.map((contactgroup, index) => (
                    <tr key={contactgroup.id}>
                      <td>{index + 1}</td>
                      <td>{contactgroup.group_name}</td>
                      <td>
                        <Link to={`/contactlist/${contactgroup.id}?contact_group=${encodeURIComponent(contactgroup.group_name)}`}>{contactgroup.contact_count}</Link>
                      </td>
                      <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>{contactgroup.description}</td>
                      <td className="dropdown">
                        <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Action
                          <span className="caret" /></button>
                        <ul className="dropdown-menu companyActions">
                              <li onClick={() => openEditModal(contactgroup.id)} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                              <i className="fa fa-edit"></i>
                              <span>Edit group</span>
                              </li>
                              <li onClick={() => { openContacts(contactgroup.id, contactgroup.group_name) }} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                              <i className="fa fa-user"></i>
                              <span>Contacts</span>
                              </li>
                              <li onClick={() => deleteContactGroup(contactgroup.id)} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                              <i className="fa fa-trash"></i>
                              <span>Delete group</span>
                              </li>
                        </ul>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  )
}

export default ContactGroupsForCompany
